module.exports = __webpack_public_path__ + "static/img/icoImg2.01c5821.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloads/icoImg2.png
// module id = 2PUl
// module chunks = 23